<template>
  <div class="list-table">
    <v-container fluid grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12>
          <v-select
            :items="distributors"
            item-text="name"
            item-value="id"
            label="Distribuidor"
            no-data-text="Datos no disponibles"
            v-model="filter.distId"
          ></v-select>
        </v-flex>
        <v-flex xs4>
          <v-dialog
            :return-value.sync="filter.startDate"
            full-width
            ref="dialog"
            v-model="modalFilterDate"
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                append-icon="event"
                label="Fecha"
                readonly
                v-model="filter.startDate"
                v-on="on"
                v-validate="'required'"
              ></v-text-field>
            </template>
            <v-date-picker locale="es-es" scrollable v-model="filter.startDate">
              <v-spacer></v-spacer>
              <v-btn @click="modalFilterDate = false" color="primary" flat text
                >Cancel</v-btn
              >
              <v-btn
                @click="$refs.dialog.save(filter.startDate)"
                color="primary"
                flat
                text
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs4>
          <v-select
            :items="options"
            item-text="name"
            v-model="filter.option"
            item-value="id"
            label="Opcion"
            no-data-text="Datos no disponibles"
          ></v-select>
        </v-flex>
        <v-flex xs4>
          <v-text-field
            placeholder="Buscar"
            v-model="filter.term"
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex md12 text-xs-right xs12>
          <v-spacer></v-spacer>
          <v-btn @click="onSearch" icon color="info">
            <v-icon>search</v-icon>
          </v-btn>
          <v-btn @click="onDownload" icon color="success">
            <v-icon>cloud_download</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :items="invoices"
                :loading="pagination.loading"
                :total-items="pagination.totalItems"
                hide-actions
                no-data-text="Datos no disponibles"
                no-results-text="No se encontraron registros coincidentes"
                v-model="complex.selected"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-left">{{ props.item.invoiceNumber }}</td>
                  <td class="text-sm-left">
                    {{ props.item.dist_invoices.name }}
                  </td>
                  <td class="text-sm-left">{{ props.item.admissionDate }}</td>
                  <td class="text-sm-left">{{ props.item.fdcontrolNumber }}</td>
                  <td class="text-sm-left">{{ props.item.departureDate }}</td>

                  <td class="text-sm-center">
                    <v-chip
                      :color="getColorByTransitStatusClient(props.item)"
                      label
                      small
                      text-color="white"
                      >{{ getLabelByTransitStatus(props.item) }}</v-chip
                    >
                  </td>
                  <td class="text-sm-center">
                    <v-btn @click="handleDetails(props.item)" color="info"
                      >detalles</v-btn
                    >
                  </td>
                  <td class="text-sm-center">
                    <v-btn
                      v-if="props.item.photoDenied"
                      @click="handleComment(props.item)"
                      color="error"
                      text
                      >ver adjunto</v-btn
                    >
                  </td>
                  <td class="text-sm-center">
                    <v-badge
                      :color="props.item.liquidated == 'NO' ? 'grey' : 'green'"
                      overlap
                    >
                      <span slot="badge">&nbsp;</span>
                    </v-badge>
                  </td>
                  <td class="text-sm-center">
                    <v-btn
                      v-if="props.item.hasFiles"
                      @click="triggerFilesDownload(props.item.id)"
                      icon
                      outlined
                    >
                      <v-icon>archive</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
          <div class="text-xs-center pt-2" v-if="pagination.pages">
            <v-pagination
              :length="pagination.pages"
              @input="asyncPagination"
              :total-visible="7"
              v-model="pagination.page"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog max-width="1024" v-if="detail.data" v-model="detail.show">
      <compose
        :item="detail.data"
        :key="detail.key"
        v-on:close-detail="detail.show = false"
      ></compose>
    </v-dialog>

    <v-dialog
      max-width="500"
      v-if="information.data"
      v-model="information.show"
    >
      <information
        :key="information.key"
        :item="information.data"
        v-on:close-information="information.show = false"
      ></information>
    </v-dialog>

    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>
    <v-dialog max-width="500" v-if="msgDialog.message" v-model="msgDialog.show">
      <message
        :options="msgDialog"
        v-on:close="msgDialog.show = false"
      ></message>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import information from './../dialog/DialogInformation'
import compose from './../dialog/DialogDetails'
import loading from './../dialog/DialogLoading'
import message from './../dialog/Message'
import {
  getColorByTransitStatusClient,
  getLabelByTransitStatus,
} from '@/helpers/TransitHelper'
import SessionHelper from '@/helpers/SessionHelper'

export default {
  components: {
    compose,
    loading,
    information,
    message,
  },
  data() {
    return {
      search: '',
      modalFilterDate: false,
      distributors: [],
      loading: true,
      pagination: {
        page: 1,
        rpp: this.$config.resultsPerPage,
        totalItems: 0,
        loading: true,
        pages: 0,
        search: {},
      },
      options: [
        {
          name: 'Todas las facturas',
          id: 'all',
        },
        {
          name: 'Facturas aprobadas',
          id: 'approved',
        },
        {
          name: 'Facturas rechazadas',
          id: 'rejected',
        },
        {
          name: 'Facturas en F&D',
          id: 'fd',
        },
        {
          name: 'Facturas entregadas',
          id: 'delivered',
        },
        {
          name: 'Desviacion',
          id: 'desviation',
        },
      ],
      filter: {
        startDate: '',
        distId: '',
        option: '',
        term: '',
      },
      detail: {
        show: null,
        data: null,
        key: 0,
      },
      dialog: {
        show: null,
      },
      msgDialog: {
        show: false,
      },
      information: {
        show: null,
        data: null,
        key: 0,
      },
      complex: {
        headers: [
          {
            text: 'Facturas',
            sortable: false,
            value: 'invoiceNumber',
            align: 'left',
          },
          {
            text: 'Distribuidor',
            sortable: false,
            value: 'dist_invoices.name',
            align: 'left',
          },
          {
            text: 'Ingreso',
            sortable: false,
            value: 'admissionDate',
            align: 'left',
          },
          {
            text: 'Control F&D',
            sortable: false,
            value: 'fdcontrolNumber',
            align: 'left',
          },

          {
            text: 'Salida',
            sortable: false,
            value: 'departureDate',
            align: 'left',
          },

          {
            text: 'Estado',
            sortable: false,
            align: 'center',
          },
          {
            text: 'Detalles',
            sortable: false,
            align: 'center',
          },
          {
            text: 'Adjunto',
            sortable: false,
            align: 'center',
          },
          {
            text: 'Pagos',
            sortable: false,
            align: 'center',
          },
          {
            text: 'Archivos',
            sortable: false,
            align: 'center',
          },
        ],
      },
    }
  },

  computed: {
    ...mapState({
      invoices: state => state.invoices.all,
    }),
  },
  created() {
    this.$store.dispatch('distributors/getAll', {}).then(response => {
      const data = response.items
      for (let index = 0; index < data.length; index += 1) {
        this.distributors.push({
          name: data[index].name,
          id: data[index].id,
        })
      }
    })

    this.asyncPagination()
  },
  methods: {
    helperPaginate(response) {
      this.pagination.totalItems = response.total
      this.pagination.pages =
        Math.ceil(this.pagination.totalItems / this.pagination.rpp) || 0
      this.loading = false
      this.pagination.loading = false
    },
    asyncPagination() {
      this.pagination.loading = true
      const filter = {
        rpp: this.pagination.rpp,
        page: this.pagination.page,
        ...this.pagination.search,
      }
      return new Promise(resolve => {
        this.$store.dispatch('invoices/getAll', filter).then(response => {
          this.helperPaginate(response)
          return resolve()
        })
      })
    },
    handleComment(row) {
      this.information = {
        data: { type: 'rejected', ...row },
        show: true,
        key: this.information + 1,
      }
    },
    onSearch() {
      const params = { ...this.filter }

      Object.keys(params).forEach(function(key) {
        if (params[key] == null || params[key] == '') delete params[key]
      })

      this.pagination.search = params
      this.pagination.page = 1
      this.asyncPagination()
    },
    onDownload() {
      const filter = {
        ...this.pagination.search,
        token: SessionHelper.token,
      }
      this.$socket.emit('exportTransitInvoices', filter)
    },
    handleDetails(row) {
      this.loading = true
      this.$store
        .dispatch('invoices/getItems', { invoiceId: row.id })
        .then(items => {
          this.loading = false
          this.detail = {
            data: { ...row, products: items ? items : null },
            show: true,
            key: this.key + 1,
          }
        })
    },
    triggerFilesDownload(id) {
      const params = {
        invoiceId: id,
        token: SessionHelper.token,
      }
      this.$socket.emit('downloadInvoiceFiles', params)
    },
    getColorByTransitStatusClient,
    getLabelByTransitStatus,
  },
  sockets: {
    downloadInvoiceAttachmentsError(message) {
      this.msgDialog = {
        message: message,
        color: 'error',
        show: true,
      }
    },
  },
}
</script>
